import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { Button } from "./ui/button";

export const waNomor = (j) => { const n = (j?.whatsapp || j?.nomor_hp || "").replace(/\D/g, ""); return n ? n.replace(/^0/, "62") : null; };

// Tombol Chat WA & WA Call (wa.me membuka chat; panggilan dimulai dari layar chat WhatsApp)
export const WaButtons = ({ jemaat, size = "sm", testId = "wa" }) => {
  const n = waNomor(jemaat);
  if (!n) return <span className="text-xs text-slate-400 italic" data-testid={`${testId}-kosong`}>No. HP belum ada</span>;
  return (
    <span className="inline-flex gap-1.5 flex-wrap">
      <Button asChild size={size} variant="outline" className="rounded-xl border-emerald-300 text-emerald-700 hover:bg-emerald-50 min-h-[36px]"><a href={`https://wa.me/${n}`} target="_blank" rel="noreferrer" data-testid={`${testId}-chat`}><MessageCircle className="h-4 w-4 mr-1" /> Chat WA</a></Button>
      <Button asChild size={size} variant="outline" className="rounded-xl border-emerald-300 text-emerald-700 hover:bg-emerald-50 min-h-[36px]"><a href={`https://wa.me/${n}?text=${encodeURIComponent("Shalom, kami dari Tim Kunjungan GKPY ingin menghubungi Anda melalui panggilan WhatsApp.")}`} target="_blank" rel="noreferrer" title="Buka WhatsApp lalu tekan ikon telepon untuk memanggil" data-testid={`${testId}-call`}><Phone className="h-4 w-4 mr-1" /> WA Call</a></Button>
    </span>
  );
};
